import EditorTabs from 'components/DocumentDetail/Editor/EditorTabs'
import Form from 'components/DocumentDetail/Editor/GeneralOcr/Form'
import Text from 'components/DocumentDetail/Editor/GeneralOcr/Text'
import { DocumentGeneral } from 'entities/DocumentsGeneral'
import { useAlert } from 'hooks/useDialog'
import { useCallback } from 'react'
import { useFormContext } from 'react-hook-form'

interface ClipboardItemIF {
  readonly types: string[]
  readonly presentationStyle: 'unspecified' | 'inline' | 'attachment'
  getType(): Promise<Blob>
}

interface ClipboardItemData {
  [mimeType: string]: Blob | string | Promise<Blob | string>
}

declare let ClipboardItem: {
  prototype: ClipboardItemIF
  new (itemData: ClipboardItemData): ClipboardItemIF
}

interface Props {
  docDetail: DocumentGeneral
}

function makeHTMLTableClip(d: DocumentGeneral): string[] {
  /* eslint-disable prefer-template */
  return d.tablesByRowCol.map(
    (t) =>
      '<table>' +
      t
        .map(
          (r) =>
            '<tr>' +
            r
              .map((c) => `<td colSpan=${c.columnSpan} rowSpan=${c.rowSpan}>${c.editedText}</td>`)
              .join('') +
            '</tr>',
        )
        .join('') +
      '</table>',
  )
  /* eslint-enable prefer-template */
}

function makeTsvTableClip(d: DocumentGeneral): string[] {
  return d.tablesByRowCol.map((t) => t.map((r) => r.map((c) => c.editedText).join('\t')).join('\n'))
}

function GeneralOcr({ docDetail }: Props) {
  const alert = useAlert()
  const { getValues } = useFormContext()

  const handleCopy = useCallback(
    (tabIdx: number) => {
      const textClip =
        tabIdx === 0 ? getValues().editedText : makeTsvTableClip(docDetail).join('\n')

      const htmlClip =
        tabIdx === 0
          ? ''
          : makeHTMLTableClip(docDetail)
              .map((clip) => `<div>${clip}</div>`)
              .join('')

      if (textClip) {
        ;(navigator.clipboard as any).write([
          htmlClip
            ? new ClipboardItem({
                'text/html': new Blob([htmlClip], { type: 'text/html' }),
                'text/plain': new Blob([textClip], { type: 'text/plain' }),
              })
            : new ClipboardItem({
                'text/plain': new Blob([textClip], { type: 'text/plain' }),
              }),
        ])
        alert({ message: 'コピーしました。' })
      } else {
        alert({ message: 'コピーする内容がありません' })
      }
    },
    [docDetail, alert, getValues],
  )

  return (
    <EditorTabs labels={['テキスト', '表形式']} handleCopy={handleCopy}>
      <Text disabled={!docDetail.canEdit()} />
      <Form docDetail={docDetail} disabled={!docDetail.canEdit()} />
    </EditorTabs>
  )
}

export default GeneralOcr
